import WindowHeader from '../modules/window-header/src/window-header'

export default WindowHeader;


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/ref/window-header.js